<template>
  <footer class="footer">
    <div id="div-footer" style="width: 100%; height: 150px; padding: 15px;"
    >
      <div class="footer__logo">
        <img :src="imagem.url" />
      </div>
      <div class="footer__info-div">
        <div class="footer__list">
          <!-- <span>Política de Privacidade</span>
          <span>Informações de Suporte</span> -->
        </div>
        <div>
          <span>version: {{ version }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterHome",
  props: ["version"],
  data() {
    return {
      imagem: this.imagens.find((img) => img.nome === "mais-futuro-logo-branca"),
    };
  },
};
</script>

<style>
.footer {
  height: 150px;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: #033166;
  color: #dddddd;
  font-size: 14px;
  font-weight: 500;
}
.footer__logo {
  text-align: center;
}
.footer__logo > img {
  height: 60px;
}
.footer__info-div {
  margin-top: 20px;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
.footer__list {
  display: flex;
  flex-flow: column;
}
</style>
